export const isDefined = (v: unknown) => v !== null && v !== undefined;

export const isNonEmptyArray = (v: unknown): v is Array<unknown> => Array.isArray(v) && v.length > 0;
